import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; 
import WhoWeAre2 from './WhoWeAre2';
import OurTeam from './OurTeam';
import LatestBlogs from './LatestBlogs';
import CustomButton from './CustomButton';
import RelatedServices from './RelatedServices';
import StudyCase from './StudyCase';
import SeoHelmet from './SeoHelmet';
import { slugify } from '../utils/slugify';
const servicesData = require('../data/services2.json'); 

const ServiceInternalPage2 = () => {
  const { serviceTitle } = useParams(); 
  const navigate = useNavigate(); 
  const [selectedService, setSelectedService] = useState(null);

  const handleClick = () => {
    navigate('/contact');
  };
  useLayoutEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  }, [serviceTitle]);

  useEffect(() => {
    const service = servicesData.services.find(
      (item) => slugify(item.title) === serviceTitle
    );


    if (service) {
      setSelectedService(service);
    } else {
      navigate('/404', { replace: true }); 
    }
  }, [serviceTitle, navigate]);

  if (!selectedService) {
    return <div>Loading...</div>; 
  }
  const headerImageUrl = require(`../images/${selectedService.introduction.hedaerImage}`);
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: selectedService.title,
    description: selectedService.meta_description,
    provider: {
      "@type": "Organization",
      name: "Web5Solution",
      url: "https://web5solution.com",
    },
    url: `https://web5solution.com/services/${serviceTitle}`,
  };

  return (
    <div>
      <SeoHelmet
        title={selectedService.meta_title}
        description={selectedService.meta_description}
        keywords={selectedService.meta_keywords}
        path={`/services/${serviceTitle}`}
        image={headerImageUrl}
        type="website"
        titleSuffix={false}
        truncateTitle={false}
        structuredData={serviceSchema}
      />
      <div className='serviceInternal-header' 
      style={{
       backgroundImage: `url(${headerImageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      >
        <div className='serviceInternal-content'>
          <h1 style={{fontSize: "2.2rem"}}>{selectedService.title}</h1>
          {console.log('Selected Service title == >> ', selectedService.title)}
          <p>{selectedService.introduction.description}</p>
          <CustomButton buttonText='Let’s Chat'  onClick={handleClick} />
        </div>
{/* 
        <div className='serviceInternal-Image'>
          {selectedService.introduction.hedaerImage && (
            <img
              src={require(`../images/${selectedService.introduction.hedaerImage}`)}
              alt={selectedService.title}
            />
          )}
        </div> */}
      </div>

      <div className='serviceInternal-div'>
        <div className='serviceImage-internal-div'>
          {selectedService.detailed_description.detailed_descriptionImage && (
            <img
              src={require(`../images/${selectedService.detailed_description.detailed_descriptionImage}`)}
              className='serviceImage-internal'
              alt='Service'
              loading='lazy'
            />
          )}
        </div>
        <div className='service-internal-content2'>
          <h2 style={{marginBottom: "20px"}}>{selectedService.title1}</h2>
          {selectedService.detailed_description.description
  .split('\n\n') 
  .map((paragraph, index) => (
    <p key={index}>
      {paragraph.split('\n').map((line, lineIndex) => (
        <React.Fragment key={lineIndex}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </p>
  ))}
        </div>
      </div>

      <RelatedServices servicesOffered={selectedService.services_offered} />
      <OurTeam />
      <WhoWeAre2 chooseUs={selectedService.why_choose_us}/>
      <StudyCase useCases={selectedService.use_cases} />
      <LatestBlogs />
    </div>
  );
};

export default ServiceInternalPage2;
